<script>

import axios from "axios";
import i18n from "../i18n";
// import simplebar from "simplebar-vue";
import { utils } from "../helpers/utils";

 /* eslint-disable no-console */
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/km.jpg"),
          language: "km",
          title: " ភាសារខ្មែរ",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: " English",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: " Chinese",
        }
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      user: JSON.parse(localStorage.getItem('user')),
      photo: '',
      profile: ''
    };
  },
  components: {  },
  mounted() {
    i18n.locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en';
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

    // console.log(location.host);

    this.profile = this.user != null && utils.capitalize(this.user.name);
    this.photo = this.user != null && this.user.photo != '' ? utils.renderImage(this.user.photo) : '';

  },
  methods: {
    // capitalize: helpers.capitalize,
    logout: function() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      this.$router.push({
        name: "login",
      });

      // this.$router.push(this.$route.query.redirectFrom || {
      //   name: "dashboard",
      // });
    },
  
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;

      localStorage.locale = locale;
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
        this.$router.push({
          name: "default",
        });
      });
    },

    reset() {
      for (let key in localStorage) {
          // if(key != 'client' &&  key != 'locale') {
          //   localStorage.removeItem(key);
          // }

          if(key != 'locale') {
            localStorage.removeItem(key);
          }
      }

      this.$swal.fire({
        title: i18n.t('general.updated.title'),
        text: i18n.t('general.updated.message'),
        icon: "success",
        confirmButtonText: i18n.t('general.ok')
      }).then(result => {
        if (!result.value) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "login"
          });
        } 
      });
    },

    property() {
      this.$router.push({
        name: "dashboard",
      });
    },

    management() {
      this.$router.push({
        name: "manage-home",
      });
    },

    accounting() {
      this.$router.push({
        name: "account-home",
      });
    },

  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="36" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <!-- <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form> -->
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="management"
          >
            <i class="bx bx-terminal"></i>
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="accounting"
          >
            <i class="bx bx-dollar-circle"></i>
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="reset"
          >
             <i class="bx bx-cloud-download"></i>
          </button>
        </div>
        
        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <div class="dropdown d-none d-lg-inline-block ml-1">
              <img
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/avatar-0.png"
                :alt="profile"
              />
            </div>
            <!-- <div v-if="photo == ''" class="dropdown d-none d-lg-inline-block ml-1">
              <img
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/avatar-0.png"
                :alt="profile"
              />
            </div>
            <div v-else class="dropdown d-none d-lg-inline-block ml-1">
              <img
                class="rounded-circle header-profile-user"
                :src="photo"
                :alt="profile"
              />
            </div> -->
            <span class="d-none d-xl-inline-block ml-2" style="margin-left: 5px">
              {{profile}}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link tag="span" to="/contacts/profile">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.user.list.profile")}}
            </router-link>
          </b-dropdown-item>
           <b-dropdown-item>
            <router-link tag="a" to="/setting">
              <i class="bx bx-wrench font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.user.list.settings") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item href="javascript: void(0);">
            <i class="bx bx-lock-open font-size-16 align-middle mr-1"></i>
            {{ $t("navbar.dropdown.user.list.lockscreen") }}
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link tag="span" to="/changepassword">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.user.list.changePassword")}}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <a
            href=""
            @click.prevent="logout"
            class="dropdown-item text-danger"
          >
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.user.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
